/// <reference path="../../node_modules/@types/node/index.d.ts" />

import { Component, h } from 'preact';
import { widgetConfiguration } from '@sgwt-widget/core';
const packageVersion = require('../../package.json').version;

interface IState {}
interface IWidgetTrackerProps {
  widgetName: string;
}
const PIWIK_UAT = {
  url: 'https://sg-analytics-uat.fr.world.socgen/piwik',
  id: 877539708
};
const PIWIK_PROD = {
  url: 'https://t-log.sgmarkets.com',
  id: 212
};

export default class WidgetTracker extends Component<IWidgetTrackerProps, IState> {
  private alreadyRendered: boolean;

  constructor(props: IWidgetTrackerProps) {
    super(props);
    this.alreadyRendered = false;
  }

  render(props: IWidgetTrackerProps): JSX.Element {
    // Avoid resending the Piwik information when this widget is re-rendered. This happens for example when the original
    // widget is re-rendered after a property modification.
    if (this.alreadyRendered) {
      return <div/>;
    }
    this.alreadyRendered = true;

    const now = new Date();
    const currentUrl = encodeURIComponent(window.location.href.replace(new RegExp('#.*'), ''));
    const customVar = {
      1: ['widget-name', props.widgetName],
      2: ['widget-version', packageVersion],
      3: ['widget-full-info', `${props.widgetName}@${packageVersion}`],
      4: ['widget-current-location', window.location.href]
    };
    const piwik = widgetConfiguration().environment.toLowerCase() === 'production' ? PIWIK_PROD : PIWIK_UAT;

    const piwikURL =
      `${piwik.url}/piwik.php?rec=1&idsite=${piwik.id}` +
      `&action_name=${props.widgetName}` +
      `&r=${String(Math.random()).slice(2, 8)}` +
      `&url=${currentUrl}` +
      `&h=${now.getHours()}&m=${now.getMinutes()}&s=${now.getSeconds()}` +
      `&_cvar=${encodeURIComponent(JSON.stringify(customVar))}` +
      `&res=${window.screen.width}x${window.screen.height}`;

    return <img src={piwikURL} style={{ border: 0, display: 'none' }} alt="" />;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/common/WidgetTracker.tsx